import { Routes } from '@angular/router';
import { CommunityHomeService } from './community-home/community-home.service';
import { slugGuard } from 'src/app/common/slug/slug.guard';

export const COMMUNITY_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./community.component').then(c => c.CommunityComponent),
    data: {
      preload: true,
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./community-home/community-home.component').then(c => c.CommunityHomeComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./community-home/community-all/community-all.component').then(c => c.CommunityAllComponent),
            data: {
              preload: true,
            },
          },
          {
            path: 'i-miei-post',
            loadComponent: () =>
              import('./community-home/community-my-posts/community-my-posts.component').then(
                c => c.CommunityMyPostsComponent,
              ),
            data: {
              preload: true,
            },
          },
          {
            path: 'my-posts',
            loadComponent: () =>
              import('./community-home/community-my-posts/community-my-posts.component').then(
                c => c.CommunityMyPostsComponent,
              ),
            data: {
              preload: true,
            },
          },
          {
            path: 'meine-posts',
            loadComponent: () =>
              import('./community-home/community-my-posts/community-my-posts.component').then(
                c => c.CommunityMyPostsComponent,
              ),
            data: {
              preload: true,
            },
          },
          {
            path: 'mis-publicaciones',
            loadComponent: () =>
              import('./community-home/community-my-posts/community-my-posts.component').then(
                c => c.CommunityMyPostsComponent,
              ),
            data: {
              preload: true,
            },
          },
          {
            path: 'mes-publications',
            loadComponent: () =>
              import('./community-home/community-my-posts/community-my-posts.component').then(
                c => c.CommunityMyPostsComponent,
              ),
            data: {
              preload: true,
            },
          },
        ],
      },
      {
        path: ':slug',
        loadComponent: () =>
          import('./community-single-post/community-single-post.component').then(c => c.CommunitySinglePostComponent),
        canActivate: [slugGuard],
        data: {
          contentType: 'post',
        },
      },
    ],
    providers: [CommunityHomeService],
  },
];
